var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandsRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Custom-BD001-clock-check",
    transform: "translate(6988 6637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Size",
    width: 48,
    height: 48,
    transform: "translate(-6988 -6637)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2227",
    "data-name": "Grupo 2227",
    transform: "translate(-6986.464 -6628.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_-_Banking_-_ic_dealer_reseller",
    "data-name": "Icons - Banking - ic_dealer_reseller",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.861,19.415l-3.67-2.669v2.276a1.12,1.12,0,0,1-1.12,1.12H4.445A4.45,4.45,0,0,1,0,15.7V1.12A1.12,1.12,0,0,1,1.12,0h8.951a1.12,1.12,0,0,1,1.12,1.12V2.238h6.043L20.98.332c1.571-.552,2.653-.363,4.814.5l7.777,3.11V1.12A1.12,1.12,0,0,1,34.692,0h8.951a1.121,1.121,0,0,1,1.12,1.12V15.7a4.45,4.45,0,0,1-4.445,4.445H34.692a1.12,1.12,0,0,1-1.12-1.12V17.06l-.194-.174L29.9,19.415a12.788,12.788,0,0,1-15.038,0ZM16.176,17.6a10.55,10.55,0,0,0,12.408,0l3.092-2.249-8.82-7.929-.369.175c-.842.4-1.811.9-2.892,1.485-2.23,1.2-4.6,1.114-5.7-.737a3.308,3.308,0,0,1,.295-3.871h-3v9.5Zm19.633.3h4.508A2.211,2.211,0,0,0,42.523,15.7V2.238H35.809ZM2.238,15.7A2.211,2.211,0,0,0,4.445,17.9H8.951V2.238H2.238ZM23.806,5.271l9.721,8.738.044-.032V6.354L24.965,2.911c-1.692-.675-2.33-.788-3.1-.526L17.286,4.721c-1.529.9-1.9,1.756-1.462,2.49.336.572,1.4.612,2.705-.093,1.114-.6,2.115-1.114,2.987-1.533.528-.254.9-.423,1.1-.51a1.117,1.117,0,0,1,1.19.2Z",
    fill: "#ec0000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsRed);
export default __webpack_public_path__ + "static/media/hands-red.55201051d5866a9283f458142c85964a.svg";
export { ForwardRef as ReactComponent };